import React from "react";

export const MicrosoftLogo: React.FC<{
  size?: number;
  className?: string;
}> = (props) => {
  return (
    <svg
      viewBox="0 0 512 512"
      className={props.className}
      xmlns="http://www.w3.org/2000/svg"
      style={{ width: props.size || "100%", height: props.size || "100%" }}
    >
      <path d="M31.87,30.58H244.7V243.39H31.87Z" fill="currentColor" />
      <path d="M266.89,30.58H479.7V243.39H266.89Z" fill="currentColor" />
      <path d="M31.87,265.61H244.7v212.8H31.87Z" fill="currentColor" />
      <path d="M266.89,265.61H479.7v212.8H266.89Z" fill="currentColor" />
    </svg>
  );
};
